<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2024.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2024-08-18                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div>
    <product-category-header style="margin-top: 70px"
                             :current-category="current_category"
                             :parent-category="parent_category"
                             v-on:category-selected="selectCategory"></product-category-header>
    <product-category-subcategory-cards v-if="current_category.ui_template === CATEGORY_UI_TEMPLATES.SUBCATEGORY_CARDS.value"
                                        :category="current_category"
                                        :subcategories="items"
                                        v-on:category-selected="selectCategory"></product-category-subcategory-cards>
    <product-category-non-bto-structure-only v-if="current_category.ui_template === CATEGORY_UI_TEMPLATES.NON_BTO_STRUCTURE_ONLY.value"
                                             :category="current_category"
                                             :is-public="isPublic"
                                             :category_assignments="category_assignments"></product-category-non-bto-structure-only>
    <product-category-non-bto-and-bto-list v-if="current_category.ui_template === CATEGORY_UI_TEMPLATES.NON_BTO_STRUCTURE_BTO_SUBCATEGORY.value"
                                           :category="current_category"
                                           :subcategories="items"
                                           :is-public="isPublic"
                                           :category_assignments="category_assignments"
                                           v-on:category-selected="selectCategory"></product-category-non-bto-and-bto-list>
    <product-category-bto-structure-list v-if="current_category.ui_template === CATEGORY_UI_TEMPLATES.BTO_STRUCTURE_LIST.value"
                                           :category="current_category"
                                           :subcategories="items"
                                           :is-public="isPublic"
                                           :category-assignments="category_assignments"></product-category-bto-structure-list>
    <yega1-axios-data-source ref="data_source"
                             store-name="ConfigurationCategoriesStore"
                             :initial-load="!!$route.params.parent_category_id"
                             :store-query="{parent_category_id: $route.params.parent_category_id}"></yega1-axios-data-source>
    <yega1-axios-show-data-source store-name="ConfigurationCategoriesStore"
                                  :store-parameter="''+$route.params.parent_category_id"
                                  :initial-load="!!$route.params.parent_category_id"
                                  v-on:item-loaded = "handleCategoryShowLoaded"
                                  ref="show_data_source"
    ></yega1-axios-show-data-source>
  </div>
</template>

<script>
import useCurrencyFormatter from "../../compositions/use-currency-formatter";
import Yega1AxiosDataSource from "@/components/yega/yega1/yega1-axios-data-source.vue";
import Yega1AxiosShowDataSource from "@/components/yega/yega1/yega1-axios-show-data-source.vue";
import {BIconChevronLeft} from "bootstrap-vue";
import ConfigureAccessoryDialog from "@/components/dynabook_shared/configure-accessory-dialog.vue";
import ConfigureAccessorySummary from "@/components/dynabook_shared/configure-accessory-summary.vue";
import ConfigurationDialogButtons from "@/components/dynabook_shared/configuration-dialog-buttons.vue";
import ProductCategoryProducts from "@/components/dynabook_shared/product-category-products.vue";
import YesNo from "@/enums/yes-no";
import ProductCategoryHeader from "@/components/dynabook_shared/product-category-header.vue";
import ProductCategorySubcategoryCards from "@/components/dynabook_shared/product-category-subcategory-cards.vue";
import {CATEGORY_UI_TEMPLATES} from "@/enums/category-ui-templates";
import ProductCategoryNonBtoStructureOnly
  from "@/components/dynabook_shared/product-category-non-bto-structure-only.vue";
import ProductCategoryNonBtoAndBtoList from "@/components/dynabook_shared/product-category-non-bto-and-bto-list.vue";
import ProductCategoryBtoStructureList from "@/components/dynabook_shared/product-category-bto-structure-list.vue";

export default {
  name: "product-category-selection",
  components: {
    ProductCategoryBtoStructureList,
    ProductCategoryNonBtoAndBtoList,
    ProductCategoryNonBtoStructureOnly,
    ProductCategorySubcategoryCards,
    ProductCategoryHeader,
    ProductCategoryProducts,
    ConfigurationDialogButtons, ConfigureAccessorySummary, ConfigureAccessoryDialog,
    Yega1AxiosShowDataSource,
    Yega1AxiosDataSource,
    BIconChevronLeft
  },
  provide() {
    return {
      setItems: this.setItems,
      registerDataSource: this.registerDataSource,
      registerItemsReceiver: this.registerItemsReceiver
    };
  },
  data() {
    return {
      CATEGORY_UI_TEMPLATES: CATEGORY_UI_TEMPLATES,
      YesNo: YesNo,
      CurrentUserStore:this.$store.state.CurrentUserStore,
      items_receivers: [],
      filtered_items: [],
      filtered_items_receivers: [],
      items: [],
      category_assignments: [],
      quote_products: [],
      current_category: {parent_category_id: this.$route.params.parent_category_id, name:null,cfg_category_assignments:[]},
      parent_category:{}
    };
  },
  created(){
    if(!this.$route.params.parent_category_id){
      this.loadCatalog();
    }else{
      this.loadCategoryAssignments(this.$route.params.parent_category_id);
    }
  },
  watch: {
    '$route.params.parent_category_id': function(newId, oldId) {
      if (newId !== oldId && !!newId) {
        this.$refs.show_data_source.reloadItem(newId);
        this.$refs.data_source.loadItems({ parent_category_id: newId });
        this.loadCategoryAssignments(newId);
      }
    }
  },
  computed:{
    parent_category_id(){
      return this.current_category.parent_category_id;
    },
    quote_version_id(){
      if(this.useCurrentUser){
        return this.CurrentUserStore.user.current_quote_version_id;
      }else{
        return this.$route.params.quote_version_id;
      }
    },
    quote_part_id(){
      if(this.useCurrentUser){
        return this.CurrentUserStore.user.current_quote_part_id;
      }else{
        return this.$route.params.quote_part_id;
      }
    }
  },
  methods: {
    setItems(items) {
      this.items = items;
      this.items_receivers.forEach((component) => {
        component.setItems(items);
      });
    },
    registerDataSource(data_source) {
      this.items_data_source = data_source;
    },
    registerItemsReceiver(component) {
      this.items_receivers.push(component);
    },
    loadCatalog(){
      this.$store.dispatch('ConfigurationCategoriesStore/index',{parent_category_id:null})
          .then((items)=>{
            let catalog = items[0];
            this.selectCategory(catalog.id)
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    },
    loadCategoryAssignments(category_id){
      this.$store.dispatch('ConfigurationCategoryAssignmentsStore/index',{cfg_category_id:category_id})
          .then((items)=>{
            this.category_assignments = items;
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    },
    selectCategory(category_id){
      this.$router.push({
        name: 'product_category_selection_path',  // Replace with your route's name
        params: { parent_category_id: category_id } // Update this to your specific route param
      });
    },
    handleCategoryShowLoaded(show_category){
      this.current_category = show_category;
      if(this.current_category.parent_category_id){
        this.$store.dispatch('ConfigurationCategoriesStore/show',this.current_category.parent_category_id)
            .then((item)=>{
              this.parent_category = item;
            })
            .catch((error)=>{alert(error.response ? error.response.data : error);});

      }else{
        this.parent_category = {};
      }
    }
  },
  props:{
    useCurrentUser:{
      type: Boolean,
      default:false
    },
    isPublic:{
      type: Boolean,
      default: false
    }
  },
  setup(){
    const { formatCurrency } = useCurrencyFormatter();
    return {
      formatCurrency
    };
  }
}
</script>

<style scoped>

</style>
